var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 30,
    viewBox: "0 0 46 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V30L10 20H0V0Z",
    fill: "#233544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H46V30L36 20H26V0Z",
    fill: "#233544"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitation);
export default __webpack_public_path__ + "static/media/citation.473d8c7ced58548291ff0343654df678.svg";
export { ForwardRef as ReactComponent };